import { ReactNode, CSSProperties } from 'react'

interface CardProps {
  children: ReactNode
  padding?: string
  maxWidth?: string
  style?: CSSProperties
}

export default function Card({ 
  children, 
  padding = '3rem', 
  maxWidth,
  style 
}: CardProps) {
  return (
    <div style={{
      backgroundColor: 'var(--base-000)',
      borderRadius: '1rem',
      padding,
      maxWidth,
      width: '100%',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      ...style
    }}>
      {children}
    </div>
  )
}

